function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 110,
  height: 110,
  fill: "transparent"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M78.2,71.2h-4.8v9.5h-4.3V56h8.7c2.9,0,5.1,0.6,6.6,1.9c1.5,1.3,2.3,3.1,2.3,5.6c0,1.7-0.4,3-1.2,4.2 s-1.9,2-3.3,2.6l5.5,10.3v0.2h-4.6L78.2,71.2z M73.5,67.7h4.4c1.4,0,2.6-0.4,3.4-1.1c0.8-0.7,1.2-1.7,1.2-3c0-1.3-0.4-2.3-1.1-3.1 c-0.8-0.7-1.9-1.1-3.4-1.1h-4.5V67.7z",
  fill: "#222222"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9,41.9c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7S29.4,41.9,27.9,41.9z",
  fill: "#222222"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7,41.9c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7S38.2,41.9,36.7,41.9z",
  fill: "#222222"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M88.2,45.1V32H72.3V17.2H29.6V32H13.7v43.8h15.9v10.9h26c5,6.2,12.6,10.1,21.2,10.1c15,0,27.2-12.2,27.2-27.2 C103.9,58.8,97.4,49.4,88.2,45.1z M32.6,20.2h36.7V32H32.6V20.2z M29.6,72.8H16.7V35h68.5v8.8c-2.7-0.9-5.5-1.4-8.5-1.4 c-9.1,0-17.1,4.5-22,11.3H29.6V72.8z M32.6,83.7v-7.8v-1.5V56.9h20.1c-2.1,3.8-3.2,8.2-3.2,12.8c0,5.1,1.4,9.9,3.9,14H32.6z  M76.7,93.8c-13.3,0-24.1-10.8-24.1-24.1c0-13.3,10.8-24.1,24.1-24.1c13.3,0,24.1,10.8,24.1,24.1C100.8,83,90,93.8,76.7,93.8z",
  fill: "#222222"
});

var SvgIconReprint = function SvgIconReprint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReprint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-reprint.0e681f2b.svg";
export { ForwardRef as ReactComponent };